export * from './IScrollToFullscreen';
export * from './createScrollToFullscreen';